import { render } from "./SoftKeyBoard.vue?vue&type=template&id=16697e84&scoped=true"
import script from "./SoftKeyBoard.vue?vue&type=script&lang=js"
export * from "./SoftKeyBoard.vue?vue&type=script&lang=js"

import "./SoftKeyBoard.vue?vue&type=style&index=0&id=16697e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16697e84"]])

export default __exports__